import React from 'react';
import { ReviewCoverageItem } from './review-coverage-item';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { CoveredPerson } from '../../../../global/models/coverage-model';

interface Props {
    title: string;
    declinedMessage: string;
    coveredPeople: CoveredPerson[];
    enrolled: boolean;
    planAvailable: boolean;
}

export function ReviewCoverageDisplay(props: Props) {
    const { title, declinedMessage, coveredPeople, enrolled, planAvailable } = props;

    if (!planAvailable) return null;

    if (!enrolled) return <ContentSpacer><WysiwygWithReactLink content={declinedMessage} /></ContentSpacer>;

    return (
        <ContentSpacer>
            <h3>{title}</h3>
            {
                coveredPeople?.map(cp => <ReviewCoverageItem
                    name={cp?.name}
                    relationshipLabel={cp?.relationship}
                />)
            }
        </ContentSpacer>
    );
}

